import styled from "styled-components";
import FooterMain from "./FooterMain";
import FooterSection from "./FooterSection";

const Wrapper = styled.div`

`;

function Footer() {
  return (
    <Wrapper>
      <FooterMain />
      <FooterSection />
    </Wrapper>
  );
}

export default Footer;
